import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RetalkComponent } from './pages/retalk/retalk.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { PodcastComponent } from './pages/podcast/podcast.component';
import { PodcastListingBlockComponent } from './components/podcast-listing-block/podcast-listing-block.component';
import { PillsComponent } from './pages/pills/pills.component';
import { PillListingBlockComponent } from './components/pill-listing-block/pill-listing-block.component';
import { PillComponent } from './pages/pill/pill.component';



@NgModule({
  declarations: [
    RetalkComponent,
    PodcastComponent,
    PodcastListingBlockComponent,
    PillsComponent,
    PillListingBlockComponent,
    PillComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ]
})
export class RetalkModule { }
